import {
  fetchImportLogsByStatus,
  ignoreImportLog,
  ignoreImportLogs,
  markImportLogImported,
} from '../../services/jiraImportLogs';
import { importLogTimesheet } from '../../services/jiraSync';
import { fetchJiraSyncHealth } from '../../services/jiraSyncHealth';
import { notify } from '../../store/feedback';

export default function jiraLogsHandlers(deps, api) {
  const {
    adminUsers,
    jiraImportLogs,
    setJiraImportLogs,
    setJiraSyncHealth,
    timesheetUserId,
    timesheetMonth,
  } = deps;

  async function loadJiraImportLogs() {
    const { data } = await fetchImportLogsByStatus();
    const all = data || [];
    // Auto-ignore les logs "Auteur inconnu" : auteurs exclus ou inconnus du système, rien à faire manuellement.
    const inconnus = all.filter((l) => l.reason?.startsWith('Auteur inconnu'));
    if (inconnus.length) {
      await ignoreImportLogs(inconnus);
    }
    setJiraImportLogs(all.filter((l) => !l.reason?.startsWith('Auteur inconnu')));
  }

  async function loadJiraSyncHealth() {
    const { data } = await fetchJiraSyncHealth();
    if (data) setJiraSyncHealth(data);
  }

  async function handleResolveLog(logId, action, briqueId) {
    const log = jiraImportLogs.find((l) => l.id === logId);
    if (!log) return;
    if (action === 'ignore') {
      await ignoreImportLog(logId);
      setJiraImportLogs((logs) => logs.filter((l) => l.id !== logId));
    } else if (action === 'import' && briqueId) {
      const user = adminUsers.find(
        (u) => u.email?.toLowerCase() === log.author_email?.toLowerCase(),
      );
      if (!user) {
        notify('Utilisateur introuvable pour cet email.');
        return;
      }
      const { data, error } = await importLogTimesheet(briqueId, log, user);
      if (error || data?.error) {
        notify('Erreur import : ' + (data?.error || error?.message));
        return;
      }
      await markImportLogImported(briqueId, logId, user);
      setJiraImportLogs((logs) => logs.filter((l) => l.id !== logId));
      api.loadTimesheetMonth(timesheetMonth, timesheetUserId);
    }
  }

  return { loadJiraImportLogs, loadJiraSyncHealth, handleResolveLog };
}
